<template>
    <Head>
        <title>Пользователи</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <div class="bg-white p-6">

            <div class="flex flex-col md:flex-row justify-between md:items-start gap-6 pb-6">
                <div class="flex flex-row gap-4 items-end">
                    <form method="get" :action="route('ocp.users')" class="flex flex-row gap-2 items-end" @submit.prevent="find">
                        <div class="w-96">
                            <v-input name="search" label="Поиск" type="search" v-model="search" placeholder="Введите id, имя или Email"/>
                        </div>
                        <v-button>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                            </svg>
                        </v-button>
                    </form>
                </div>

                <form v-show="access('user', 'unloading')" method="post" action="#" class="flex flex-row gap-x-4" @submit.prevent="unload">
                    <v-input label="От даты создания" type="date" v-model="unloadForm.dates[0]" :error="errors['dates.0']"/>
                    <v-input label="По, включительно" type="date" v-model="unloadForm.dates[1]" :error="errors['dates.1']"/>
                    <div class="flex pt-4">
                        <v-button color="green">Выгрузить</v-button>
                    </div>
                </form>

            </div>

            <div v-if="success">

                <div class="grid grid-cols-3 md:grid-cols-9 border-b text-sm items-end text-gray-700 font-semibold uppercase p-2 gap-4">
                    <span class="col-span-2 pl-8">email</span>
                    <span class="hidden md:block" v-if="$page.props.auth.user.role !== 'aml'">Хост</span>
                    <span class="hidden md:block" v-else></span>
                    <span class="text-center hidden md:block">язык</span>
                    <span class="hidden md:block">создан (UTC)</span>
                    <span class="hidden md:block">обновлен (UTC)</span>
                    <span class="hidden md:block">подтвержден (UTC)</span>
                    <span class="hidden md:block">авторизация (UTC)</span>
                </div>

                <div v-for="u of result.rows" class="grid grid-cols-3 md:grid-cols-9 border-b p-2 gap-4 text-sm items-center">
                    <div class="col-span-2 flex flex-row gap-4">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-4 w-4" :class="u.loginBlock ? 'text-red-600' : 'text-green-600'" viewBox="0 0 16 16">
                          <path v-if="u.loginBlock" d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1"/>
                          <path v-else d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"/>
                        </svg>
                        {{ u.email }}
                    </div>
                    <div class="hidden md:block" v-if="$page.props.auth.user.role !== 'aml'">{{ u.host }}</div>
                    <div class="hidden md:block" v-else></div>
                    <span class="text-center hidden md:block">{{ u.lang }}</span>
                    <span class="hidden md:block">{{ moment(u.createdAt).utc().format('L LTS') }}</span>
                    <span class="hidden md:block">{{ moment(u.updatedAt).utc().format('L LTS') }}</span>
                    <div v-if="u.confirmedAt" class="hidden md:block">
                        {{ moment(u.confirmedAt).utc().format('L LTS') }}
                    </div>
                    <div v-else class="hidden md:block"></div>
                    <div v-if="u.lastLoginAt" class="hidden md:block">
                        {{ moment(u.lastLoginAt).utc().format('L LTS') }}
                    </div>
                    <div v-else class="hidden md:block"></div>
                    <Link class="text-gray-500 hover:text-blue-500 pr-8" :href="route('ocp.user', u.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-auto fill-current" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </Link>
                </div>

                <div class="pt-4 flex flex-row items-center">
                    <v-pagination
                        :count="result.count"
                        :limit="limit"
                        :page="page"
                        :paginate="paginate"
                    />
                </div>

            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VPagination from "@/Components/PaginationOffset";
import moment from "moment";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VInput,
        VButton,
        VPagination,
    },
    props: {
        notifications: Array,
        success: Boolean,
        result: Object,
        search: String,
        limit: Number,
        page: Number,
        errors: Object,
    },data() {
        return {
            unloadForm: useForm({
                dates: ['', ''],
            }),
        }
    },
    methods: {
        moment,
        find() {
            const {search} = this
            useForm({search, page: 1}).get(this.route('ocp.users'));
        },
        paginate(page) {
            const { search } = this;
            useForm({search, page}).get(this.route('ocp.users'));
        },
        unload() {
            this.unloadForm.post(this.route('users.unload'));
        }
    },
}
</script>
